module.exports = __webpack_public_path__ + "static/img/logos.ba84b11a.png";